import { FormattedMessage } from 'react-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { subscriptionItemsMessages } from 'src/features/subscriptionItems/utils/messages';
import SubscriptionItemsTable from 'src/features/subscriptionItems/components/tables/SubscriptionItemsTable';
import { chargesMessages } from 'src/features/charges/utils/messages';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import PaymentsTable from 'src/features/payments/components/tables/PaymentsTable';
import { useParams } from 'react-router-dom';
import FinancialDocumentsTable from 'src/features/financialDocuments/components/tables/FinancialDocumentsTable';
import ChargesTable from 'src/features/charges/components/tables/ChargesTable';
import { discountsMessages } from 'src/features/discounts/utils/messages';
import DiscountsTable from 'src/features/discounts/components/tables/DiscountsTable';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

const SubscriptionDashboardTables = () => {
    const { subscriptionId = '' } = useParams();

    const permissionAccessSubscriptions = useHasPermissions([PERMISSION.ACCESS_SUBSCRIPTIONS]);
    const permissionAccessCharges = useHasPermissions([PERMISSION.ACCESS_CHARGES]);
    const permissionAccessFinancialDocuments = useHasPermissions([PERMISSION.ACCESS_FINANCIAL_DOCUMENTS]);
    const permissionAccessPayments = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);
    const permissionAccessDiscounts = useHasPermissions([PERMISSION.ACCESS_DISCOUNTS]);

    const showTabsAndTables =
        permissionAccessSubscriptions ||
        permissionAccessCharges ||
        permissionAccessFinancialDocuments ||
        permissionAccessPayments ||
        permissionAccessDiscounts;

    const defaultTabValue = (() => {
        if (permissionAccessSubscriptions) return 'subscription-items';
        if (permissionAccessCharges) return 'charges';
        if (permissionAccessFinancialDocuments) return 'financial-documents';
        if (permissionAccessPayments) return 'payments';
        if (permissionAccessDiscounts) return 'discounts';
    })();

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            {showTabsAndTables && (
                <Tabs defaultValue={defaultTabValue}>
                    <TabsList>
                        {permissionAccessSubscriptions && (
                            <TabsTrigger value="subscription-items">
                                <FormattedMessage {...subscriptionItemsMessages.subscriptionItems} />
                            </TabsTrigger>
                        )}
                        {permissionAccessCharges && (
                            <TabsTrigger value="charges">
                                <FormattedMessage {...chargesMessages.charges} />
                            </TabsTrigger>
                        )}
                        {permissionAccessFinancialDocuments && (
                            <TabsTrigger value="financial-documents">
                                <FormattedMessage {...financialDocumentsMessages.financialDocuments} />
                            </TabsTrigger>
                        )}
                        {permissionAccessPayments && (
                            <TabsTrigger value="payments">
                                <FormattedMessage {...paymentsMessages.payments} />
                            </TabsTrigger>
                        )}
                        {permissionAccessDiscounts && (
                            <TabsTrigger value="discounts">
                                <FormattedMessage {...discountsMessages.discounts} />
                            </TabsTrigger>
                        )}
                    </TabsList>
                    <TabsContent value="subscription-items">
                        <SubscriptionItemsTable />
                    </TabsContent>
                    <TabsContent value="charges">
                        <ChargesTable />
                    </TabsContent>
                    <TabsContent value="financial-documents">
                        <FinancialDocumentsTable />
                    </TabsContent>
                    <TabsContent value="payments">
                        <PaymentsTable item_type="subscription" item_id={subscriptionId} />
                    </TabsContent>
                    <TabsContent value="discounts">
                        <DiscountsTable />
                    </TabsContent>
                </Tabs>
            )}
        </div>
    );
};

export default SubscriptionDashboardTables;
